<section class="min-h-screen bg-[#f3f3f3] px-3 pb-8 pt-5 sm:px-5 lg:px-8">
    <div class="mx-auto max-w-[1600px]">

        <!-- Back navigation -->
        <button (click)="navigateBack()"
            class="mb-3 flex items-center gap-1.5 text-sm font-medium text-gray-500 hover:text-[#D31148] transition-colors">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M19 12H5" />
                <path d="M12 19l-7-7 7-7" />
            </svg>
            Back
        </button>

        <ng-container *ngIf="!isLoading && !hasError && eventDetails; else loading">

            <!-- Removed-by-admin banner (only ever present for the event's own author) -->
            <div *ngIf="eventDetails[0].isRemovedByAdmin"
                class="mb-3 flex items-center gap-2 rounded-lg bg-red-50 border border-red-200 text-red-700 text-xs font-medium px-3 py-2">
                <svg class="h-4 w-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
                </svg>
                <!-- Admin opened this from the admin panel (preview link) -->
                <span *ngIf="isAdminPreview; else removedOwnerText">Removed by admin — hidden from other users. Only the author can still see it.</span>
                <ng-template #removedOwnerText>
                  <span>This content has been removed by admin and is only visible to you.</span>
                </ng-template>
            </div>

            <div class="flex flex-col lg:flex-row rounded-2xl border border-[#e6e6e6] bg-white shadow-sm overflow-hidden
                        lg:h-[calc(100vh-300px)] h-[calc(100vh-105px)]">

                <!-- ── LEFT: Image panel ──────────────────────────────────── -->
                <div class="relative w-full lg:w-[58%] flex-shrink-0 h-56 sm:h-72 lg:h-full bg-gray-950
                            rounded-t-2xl lg:rounded-l-2xl lg:rounded-tr-none flex items-center justify-center select-none"
                    style="overflow: visible;" appSwipe [swipeDisabled]="eventDetails[0].images.length <= 1"
                    (swipeLeft)="onHeroSwipe(1)" (swipeRight)="onHeroSwipe(-1)">

                    <div class="absolute inset-0 rounded-t-2xl lg:rounded-l-2xl lg:rounded-tr-none overflow-hidden">
                        <ng-container *ngIf="eventDetails[0].images.length > 0; else noImage">
                            <img *ngFor="let img of eventDetails[0].images; let i = index" [src]="img"
                                [alt]="eventDetails[0].title" loading="lazy"
                                class="w-full h-full object-contain absolute inset-0 carousel-slide"
                                [class.block]="i === eventDetails[0].activeSlide"
                                [class.hidden]="i !== eventDetails[0].activeSlide" />
                        </ng-container>
                        <ng-template #noImage>
                            <div class="flex items-center justify-center w-full h-full">
                                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6b7280"
                                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                                    <rect x="3" y="3" width="18" height="18" rx="2" />
                                    <circle cx="8.5" cy="8.5" r="1.5" />
                                    <polyline points="21 15 16 10 5 21" />
                                </svg>
                            </div>
                        </ng-template>
                    </div>

                    <div class="relative w-full h-full flex items-center justify-center" style="overflow:visible;">
                        <ng-container *ngIf="eventDetails[0].images.length > 1">
                            <button (click)="prevSlide(eventDetails[0], $event)"
                                class="absolute left-2 top-1/2 -translate-y-1/2 z-10 flex h-7 w-7 items-center
                                       justify-center rounded-full bg-white/80 text-[#D31148] shadow hover:bg-white transition-colors">
                                <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M15 18l-6-6 6-6" />
                                </svg>
                            </button>
                            <button (click)="nextSlide(eventDetails[0], $event)"
                                class="absolute right-2 top-1/2 -translate-y-1/2 z-10 flex h-7 w-7 items-center
                                       justify-center rounded-full bg-white/80 text-[#D31148] shadow hover:bg-white transition-colors">
                                <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M9 18l6-6-6-6" />
                                </svg>
                            </button>
                        </ng-container>
                        <div *ngIf="eventDetails[0].images.length > 1"
                            class="absolute bottom-3 left-1/2 -translate-x-1/2 flex items-center gap-1.5 z-10">
                            <button *ngFor="let img of eventDetails[0].images; let i = index"
                                (click)="eventDetails[0].activeSlide = i"
                                class="rounded-full transition-all duration-300"
                                [class]="i === eventDetails[0].activeSlide ? 'h-2 w-4 bg-white' : 'h-2 w-2 bg-white/50'">
                            </button>
                        </div>
                    </div>

                </div>

                <!-- ── RIGHT panel ────────────────────────────────────────── -->
                <div class="flex-1 flex flex-col bg-white border-t lg:border-t-0 lg:border-l border-gray-100
                            rounded-b-2xl lg:rounded-r-2xl lg:rounded-bl-none overflow-hidden min-w-0">

                    <!-- Header -->
                    <div
                        class="flex items-center justify-between px-4 sm:px-5 py-3.5 border-b border-gray-100 flex-shrink-0">
                        <div class="flex items-center gap-3 min-w-0">
                            <div class="flex-shrink-0">
                                <img *ngIf="eventDetails[0].acceptedCollaborators.length === 0"
                                    class="h-12 w-12 rounded-full object-cover ring-2 ring-[#FFD4E0]"
                                    [src]="eventDetails[0].hostAvatar" [alt]="eventDetails[0].hostName"
                                    onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />

                                <div *ngIf="eventDetails[0].acceptedCollaborators.length > 0"
                                    class="flex -space-x-2 items-center"
                                    [class.cursor-pointer]="eventDetails[0].acceptedCollaborators.length >= 1"
                                    (click)="eventDetails[0].acceptedCollaborators.length >= 1 ? showCollaboratorsModal(eventDetails[0]) : null; $event.stopPropagation()">
                                    <img class="h-11 w-11 rounded-full border-2 border-white object-cover ring-2 ring-[#FFD4E0]"
                                        [src]="eventDetails[0].hostAvatar" [alt]="eventDetails[0].hostName"
                                        onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />
                                    <img class="h-8 w-8 rounded-full border-2 border-white object-cover"
                                        [src]="eventDetails[0].acceptedCollaborators[0].profileImage?.urlSmall"
                                        [alt]="eventDetails[0].acceptedCollaborators[0].displayName"
                                        onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />
                                </div>
                            </div>
                            <div class="min-w-0">
                                <div class="flex items-center gap-3">
                                    <div class="min-w-0 font-bold text-gray-900 text-md truncate">
                                        <span class="cursor-pointer"
                                            [routerLink]="['/profile', eventDetails[0].hostName, 'event']"
                                            (click)="$event.stopPropagation()">
                                            {{ eventDetails[0].hostName }}
                                        </span>

                                        <ng-container *ngIf="eventDetails[0].acceptedCollaborators.length === 1">
                                            <span class="font-normal text-gray-500"> with </span>
                                            <span class="font-semibold text-gray-700">{{
                                                eventDetails[0].acceptedCollaborators[0].userName }}</span>
                                        </ng-container>

                                        <ng-container *ngIf="eventDetails[0].acceptedCollaborators.length >= 2">
                                            <span class="font-normal text-gray-500"> and </span>
                                            <span class="cursor-pointer font-semibold text-gray-700 hover:text-gray-900"
                                                (click)="showCollaboratorsModal(eventDetails[0]); $event.stopPropagation()">
                                                {{ eventDetails[0].acceptedCollaborators.length }} {{
                                                eventDetails[0].acceptedCollaborators.length === 1 ? 'other' : 'others'
                                                }}
                                            </span>
                                        </ng-container>
                                    </div>

                                    <button (click)="onFriendButtonClick(eventDetails[0], $event)"
                                        *ngIf="!eventDetails[0].isMyPostedEvent && eventDetails[0].acceptedCollaborators.length === 0"
                                        [disabled]="eventDetails[0].friendshipStatus === 'BLOCKED'"
                                        [title]="friendButtonTitle(eventDetails[0].friendshipStatus)" class="text-gray-400 flex-shrink-0 transition-colors
         disabled:opacity-40 disabled:cursor-not-allowed hover:text-[#D31148]">

                                        <!-- NONE: add friend -->
                                        <svg *ngIf="eventDetails[0].friendshipStatus === 'NONE'" class="h-6 w-6"
                                            viewBox="0 0 24 24" fill="none" stroke="#D31148" stroke-width="2">
                                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                            <circle cx="9" cy="7" r="4" />
                                            <line x1="19" y1="8" x2="19" y2="14" />
                                            <line x1="22" y1="11" x2="16" y2="11" />
                                        </svg>

                                        <!-- PENDING_SENT: request sent — click to cancel -->
                                        <svg *ngIf="eventDetails[0].friendshipStatus === 'PENDING_SENT'" class="h-6 w-6"
                                            viewBox="0 0 24 24" fill="none" stroke="#f97316" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round">
                                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                            <circle cx="9" cy="7" r="4" />
                                            <line x1="17" y1="8" x2="23" y2="14" />
                                            <line x1="23" y1="8" x2="17" y2="14" />
                                        </svg>

                                        <!-- PENDING_RECEIVED: they sent you a request -->
                                        <svg *ngIf="eventDetails[0].friendshipStatus === 'PENDING_RECEIVED'"
                                            class="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="#6366f1"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                            <circle cx="9" cy="7" r="4" />
                                            <polyline points="16 11 18 13 22 9" />
                                        </svg>

                                        <!-- FRIENDS: already friends — click to unfriend -->
                                        <svg *ngIf="eventDetails[0].friendshipStatus === 'FRIENDS'" class="h-6 w-6"
                                            viewBox="0 0 24 24" fill="none" stroke="#10b981" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round">
                                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                            <circle cx="9" cy="7" r="4" />
                                            <polyline points="16 11 18 13 22 9" />
                                        </svg>

                                        <!-- BLOCKED -->
                                        <svg *ngIf="eventDetails[0].friendshipStatus === 'BLOCKED'" class="h-6 w-6"
                                            viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round">
                                            <circle cx="12" cy="12" r="10" />
                                            <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
                                        </svg>

                                    </button>
                                </div>
                                <span class="text-sm text-gray-400">{{ eventDetails[0].timeAgo }}</span>
                            </div>
                        </div>
                        <div class="flex items-center gap-2 flex-shrink-0 ml-2">
                            <button *ngIf="!eventDetails[0].isMyPostedEvent" (click)="reportEvent()"
                                class="hidden sm:block px-3 py-1.5 rounded-lg border border-gray-200 text-xs font-semibold text-gray-600 hover:bg-gray-50 transition-all whitespace-nowrap">
                                Report this Event
                            </button>
                            <button
                                *ngIf="!eventDetails[0].isMyPostedEvent && !eventDetails[0].isFollowed && eventDetails[0].acceptedCollaborators.length === 0"
                                (click)="onEventFollowClick($event)"
                                class="px-4 py-1.5 rounded-lg text-xs font-bold transition-colors shadow-sm bg-[#D31148] text-white hover:bg-[#b80e3d]">
                                Follow
                            </button>

                            <!-- Three-dot action menu (all non-owner viewers get Follow/Unfollow,
                                 Report and Block here too, not just followers/collaborators —
                                 mirrors the listing page's card menu) -->
                            <div class="relative inline-block">
                                <button (click)="toggleActionMenu($event)"
                                    class="flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-200 transition-colors text-gray-500">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M10.2441 6C10.2441 5.0335 11.0276 4.25 11.9941 4.25H12.0041C12.9706 4.25 13.7541 5.0335 13.7541 6C13.7541 6.9665 12.9706 7.75 12.0041 7.75H11.9941C11.0276 7.75 10.2441 6.9665 10.2441 6ZM10.2441 18C10.2441 17.0335 11.0276 16.25 11.9941 16.25H12.0041C12.9706 16.25 13.7541 17.0335 13.7541 18C13.7541 18.9665 12.9706 19.75 12.0041 19.75H11.9941C11.0276 19.75 10.2441 18.9665 10.2441 18ZM11.9941 10.25C11.0276 10.25 10.2441 11.0335 10.2441 12C10.2441 12.9665 11.0276 13.75 11.9941 13.75H12.0041C12.9706 13.75 13.7541 12.9665 13.7541 12C13.7541 11.0335 12.9706 10.25 12.0041 10.25H11.9941Z" />
                                    </svg>
                                </button>
                                <app-dropdown [isOpen]="showActionMenu" (close)="closeActionMenu()"
                                    className="w-44 p-2 right-0">
                                    <ng-container *ngIf="eventDetails[0].isMyPostedEvent">
                                        <app-dropdown-item (itemClick)="toggleComments(); closeActionMenu()"
                                            [className]="(eventDetails[0].commentsDisabled ? 'flex w-full font-normal text-left text-red-500 rounded-lg hover:bg-red-50 hover:text-red-700 px-3 py-2 gap-2' : 'flex w-full font-normal text-left text-gray-600 rounded-lg hover:bg-gray-100 hover:text-gray-800 px-3 py-2 gap-2') + (togglingComments ? ' opacity-50 pointer-events-none' : '')">
                                            <svg *ngIf="!eventDetails[0].commentsDisabled" width="16" height="16"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0">
                                                <path
                                                    d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                                            </svg>
                                            <svg *ngIf="eventDetails[0].commentsDisabled" width="16" height="16"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0">
                                                <path
                                                    d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                                                <line x1="2" y1="2" x2="22" y2="22" />
                                            </svg>
                                            {{ eventDetails[0].commentsDisabled ? 'Turn on comments' : 'Turn off
                                            comments' }}
                                        </app-dropdown-item>
                                        <app-dropdown-item (itemClick)="editEvent(); closeActionMenu()"
                                            className="flex w-full font-normal text-left text-gray-600 rounded-lg hover:bg-gray-100 hover:text-gray-800 px-3 py-2 gap-2">
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                                stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" class="flex-shrink-0">
                                                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                                            </svg>
                                            Edit Event
                                        </app-dropdown-item>
                                        <app-dropdown-item (itemClick)="confirmDelete(); closeActionMenu()"
                                            className="flex w-full font-normal text-left text-red-500 rounded-lg hover:bg-red-50 hover:text-red-700 px-3 py-2 gap-2">
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                                stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" class="flex-shrink-0">
                                                <polyline points="3 6 5 6 21 6" />
                                                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                                                <path d="M10 11v6" />
                                                <path d="M14 11v6" />
                                                <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
                                            </svg>
                                            Delete Event
                                        </app-dropdown-item>
                                    </ng-container>
                                    <ng-container *ngIf="!eventDetails[0].isMyPostedEvent && isCollaborator">
                                        <app-dropdown-item (itemClick)="confirmLeave(); closeActionMenu()"
                                            className="flex w-full font-normal text-left text-orange-500 rounded-lg hover:bg-orange-50 hover:text-orange-700 px-3 py-2 gap-2">
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                                stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" class="flex-shrink-0">
                                                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                                                <polyline points="16 17 21 12 16 7" />
                                                <line x1="21" y1="12" x2="9" y2="12" />
                                            </svg>
                                            Leave Collaboration
                                        </app-dropdown-item>
                                    </ng-container>
                                    <!-- Non-owner actions (Follow/Unfollow always available here too,
                                         plus Report and Block — same set the listing card offers) -->
                                    <ng-container *ngIf="!eventDetails[0].isMyPostedEvent && !isCollaborator">
                                        <app-dropdown-item
                                            *ngIf="!eventDetails[0].isFollowed && eventDetails[0].acceptedCollaborators.length === 0"
                                            (itemClick)="onEventFollowClick(); closeActionMenu()"
                                            className="flex w-full font-normal text-left text-gray-600 rounded-lg hover:bg-gray-100 hover:text-gray-800 px-3 py-2 gap-2">
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                                stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" class="flex-shrink-0">
                                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                                <circle cx="9" cy="7" r="4" />
                                                <line x1="20" y1="8" x2="20" y2="14" />
                                                <line x1="17" y1="11" x2="23" y2="11" />
                                            </svg>
                                            Follow
                                        </app-dropdown-item>
                                        <app-dropdown-item
                                            *ngIf="eventDetails[0].isFollowed && eventDetails[0].acceptedCollaborators.length === 0"
                                            (itemClick)="onEventFollowClick(); closeActionMenu()"
                                            className="flex w-full font-normal text-left text-gray-600 rounded-lg hover:bg-gray-100 hover:text-gray-800 px-3 py-2 gap-2">
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                                stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" class="flex-shrink-0">
                                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                                <circle cx="9" cy="7" r="4" />
                                                <line x1="17" y1="11" x2="23" y2="11" />
                                            </svg>
                                            Unfollow
                                        </app-dropdown-item>
                                        <app-dropdown-item (itemClick)="reportEvent()"
                                            className="flex w-full font-normal text-left text-red-500 rounded-lg hover:bg-red-50 hover:text-red-700 px-3 py-2 gap-2">
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                                stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" class="flex-shrink-0">
                                                <polyline points="3 6 5 6 21 6" />
                                                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                                                <path d="M10 11v6" />
                                                <path d="M14 11v6" />
                                                <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
                                            </svg>
                                            Report Event
                                        </app-dropdown-item>
                                        <app-dropdown-item (itemClick)="blockEventUser()"
                                            className="flex w-full font-normal text-left text-red-500 rounded-lg hover:bg-red-50 hover:text-red-700 px-3 py-2 gap-2">
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                                stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" class="flex-shrink-0">
                                                <circle cx="12" cy="12" r="10" />
                                                <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
                                            </svg>
                                            Block User
                                        </app-dropdown-item>
                                    </ng-container>
                                </app-dropdown>
                            </div>
                        </div>
                    </div>

                    <!-- Tab bar -->
                    <div class="flex items-center justify-between border-b border-gray-100 flex-shrink-0 px-5">
                        <div class="flex">
                            <button (click)="switchTab('details')"
                                class="relative py-3 px-1 mr-6 text-sm font-semibold transition-colors"
                                [class.text-[#D31148]]="activeTab==='details'"
                                [class.text-gray-400]="activeTab!=='details'">
                                Details
                                <span *ngIf="activeTab==='details'"
                                    class="absolute bottom-0 left-0 right-0 h-0.5 bg-[#D31148] rounded-full"></span>
                            </button>
                            <button (click)="switchTab('comments')"
                                class="relative py-3 px-1 text-sm font-semibold transition-colors"
                                [class.text-[#D31148]]="activeTab==='comments'"
                                [class.text-gray-400]="activeTab!=='comments'">
                                Comments
                                <span *ngIf="commentsTotal > 0"
                                    class="ml-1.5 inline-flex items-center justify-center
                                    min-w-[18px] h-[18px] px-1 rounded-full bg-[#D31148] text-white text-[10px] font-bold">
                                    {{ commentsTotal }}
                                </span>
                                <span *ngIf="activeTab==='comments'"
                                    class="absolute bottom-0 left-0 right-0 h-0.5 bg-[#D31148] rounded-full"></span>
                            </button>
                        </div>

                        <!-- Tagged people + favourite star always; reaction / share / comment
                             only from lg up — below that the mobile strip at the bottom of the
                             panel carries them, and showing both duplicated every action. -->
                        <div class="flex items-center gap-4">
                            <!-- Tagged people -->
                            <button *ngIf="(eventDetails[0].rawMentions?.length ?? 0) > 0" type="button"
                                (click)="showTaggedPeopleModal(eventDetails[0], $event)" title="Tagged people"
                                class="flex items-center justify-center w-7 h-7 rounded-full hover:bg-[#FFF0F3] transition-colors text-gray-500 hover:text-[#D31148]">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                    <circle cx="9" cy="7" r="4" />
                                    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                </svg>
                            </button>
                            <!-- Reaction -->
                            <div class="relative hidden lg:flex items-center gap-1" style="overflow: visible;">
                                <div *ngIf="eventDetails[0].showEmojiPicker"
                                    class="reaction-picker absolute z-[999] flex items-end gap-1 rounded-full bg-white
                                           px-3 py-2.5 shadow-[0_4px_20px_rgba(0,0,0,0.2)] border border-gray-100 whitespace-nowrap"
                                    style="top: calc(100% + 10px); right: 0; pointer-events: auto;"
                                    (mouseleave)="closeEmojiPicker(eventDetails[0])">
                                    <button *ngFor="let r of REACTIONS; let i = index"
                                        (click)="onEmojiPick(eventDetails[0], r.type, $event)"
                                        (mouseenter)="eventDetails[0].hoveredReaction = r.type"
                                        (mouseleave)="eventDetails[0].hoveredReaction = null"
                                        class="flex flex-col items-center cursor-pointer"
                                        [style.animation-delay.ms]="i * 30" [title]="r.label">
                                        <span
                                            class="flex items-center justify-center rounded-full transition-transform duration-150"
                                            [style.background]="r.bg"
                                            [class.scale-125]="eventDetails[0].hoveredReaction === r.type"
                                            [class.-translate-y-2]="eventDetails[0].hoveredReaction === r.type"
                                            style="width:36px;height:36px;font-size:20px;line-height:1;transition:transform 0.15s cubic-bezier(0.34,1.56,0.64,1);">
                                            {{ r.emoji }}
                                        </span>
                                    </button>
                                </div>
                                <button
                                    class="flex items-center justify-center w-7 h-7 rounded-full hover:bg-[#FFF0F3] transition-colors"
                                    (click)="onReactionClick(eventDetails[0])">
                                    <ng-container *ngIf="!eventDetails[0].myReaction">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#D31148"
                                            stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                            <path d="M7 10v12" />
                                            <path
                                                d="M15 5.88L14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z" />
                                        </svg>
                                    </ng-container>
                                    <ng-container *ngIf="eventDetails[0].myReaction">
                                        <span
                                            class="flex items-center justify-center rounded-full hover:scale-110 transition-transform"
                                            [style.background]="getReactionConfig(eventDetails[0].myReaction)?.bg"
                                            style="width:24px;height:24px;font-size:14px;line-height:1;">
                                            {{ getReactionConfig(eventDetails[0].myReaction)?.emoji }}
                                        </span>
                                    </ng-container>
                                </button>
                                <span class="text-xs font-semibold"
                                    [style.color]="eventDetails[0].myReaction ? getReactionConfig(eventDetails[0].myReaction)?.color : '#4b5563'">
                                    {{ eventDetails[0].totalReactions }}
                                </span>
                            </div>



                            <!-- Share -->
                            <button class="hidden lg:flex items-center gap-1 group" (click)="openShareSheet()">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                    <g opacity="0.7">
                                        <path
                                            d="M20.7914 12.6075C21.0355 12.3982 21.1575 12.2936 21.2023 12.1691C21.2415 12.0598 21.2415 11.9403 21.2023 11.831C21.1575 11.7065 21.0355 11.6019 20.7914 11.3926L12.3206 4.13202C11.9004 3.77182 11.6903 3.59172 11.5124 3.58731C11.3578 3.58348 11.2101 3.6514 11.1124 3.77128C11 3.90921 11 4.18595 11 4.73942V9.03468C8.86532 9.40813 6.91159 10.4898 5.45971 12.1139C3.87682 13.8846 3.00123 16.176 3 18.551V19.163C4.04934 17.8989 5.35951 16.8766 6.84076 16.166C8.1467 15.5395 9.55842 15.1684 11 15.0706V19.2607C11 19.8141 11 20.0909 11.1124 20.2288C11.2101 20.3487 11.3578 20.4166 11.5124 20.4128C11.6903 20.4084 11.9004 20.2283 12.3206 19.8681L20.7914 12.6075Z"
                                            stroke="#D31148" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </g>
                                </svg>
                                <span class="text-xs font-semibold text-gray-600">{{ eventDetails[0].shares }}</span>
                            </button>

                            <!-- Comment count -->
                            <button class="hidden lg:flex items-center gap-1" (click)="switchTab('comments')">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#D31148"
                                    stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                                </svg>
                                <span class="text-xs font-semibold text-gray-600">{{ commentsTotal }}</span>
                            </button>

                            <!-- Favourite star -->
                            <button (click)="toggleFavourite(); $event.stopPropagation()"
                                [class.text-[#D31148]]="isFavourite" [class.text-gray-300]="!isFavourite"
                                [title]="isFavourite ? 'Remove from favourites' : 'Save to favourites'"
                                class="flex items-center justify-center transition-colors hover:text-[#D31148]">
                                <svg class="w-5 h-5" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round"
                                    [attr.fill]="isFavourite ? 'currentColor' : 'none'">
                                    <polygon
                                        points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                </svg>
                            </button>
                        </div>
                    </div>

                    <!-- ── DETAILS TAB ──────────────────────────────────── -->
                    <div *ngIf="activeTab==='details'"
                        class="flex-1 overflow-y-auto min-h-0 px-4 sm:px-5 py-5 space-y-4">

                        <!-- ── Collaboration invite banner ── -->
                        <div *ngIf="myCollabStatus === 'PENDING'"
                            class="rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 flex flex-col gap-2.5">
                            <div class="flex items-start gap-3">
                                <div
                                    class="flex-shrink-0 w-9 h-9 rounded-full bg-amber-100 flex items-center justify-center">
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#d97706"
                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                        <circle cx="9" cy="7" r="4" />
                                        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                    </svg>
                                </div>
                                <div class="flex-1 min-w-0">
                                    <p class="text-sm font-semibold text-amber-800">Collaboration Invite</p>
                                    <p class="text-xs text-amber-700 mt-0.5 leading-snug">
                                        You've been invited to co-host this event. Accept to appear as a co-host.
                                    </p>
                                </div>
                            </div>
                            <div class="flex gap-2">
                                <button (click)="acceptCollaboration()" [disabled]="isCollabActioning"
                                    class="flex-1 flex items-center justify-center gap-1.5 py-2 rounded-xl bg-[#D31148] text-white text-sm font-semibold disabled:opacity-50 hover:bg-[#b50e3c] transition-colors">
                                    <svg *ngIf="!isCollabActioning" width="14" height="14" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="20 6 9 17 4 12" />
                                    </svg>
                                    <svg *ngIf="isCollabActioning" class="animate-spin" width="14" height="14"
                                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                                        <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                                    </svg>
                                    Accept
                                </button>
                                <button (click)="declineCollaboration()" [disabled]="isCollabActioning"
                                    class="flex-1 flex items-center justify-center gap-1.5 py-2 rounded-xl border border-gray-200 bg-white text-gray-600 text-sm font-semibold disabled:opacity-50 hover:bg-gray-50 transition-colors">
                                    <svg *ngIf="!isCollabActioning" width="14" height="14" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <line x1="18" y1="6" x2="6" y2="18" />
                                        <line x1="6" y1="6" x2="18" y2="18" />
                                    </svg>
                                    Decline
                                </button>
                            </div>
                        </div>

                        <!-- ── Collaboration accepted confirmation ── -->
                        <div *ngIf="myCollabStatus === 'ACCEPTED'"
                            class="rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-3 flex items-center gap-3">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#059669"
                                stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0">
                                <polyline points="20 6 9 17 4 12" />
                            </svg>
                            <p class="text-sm font-medium text-emerald-800">You are a co-host of this event.</p>
                        </div>

                        <h1 class="text-2xl font-bold text-[#000000] leading-snug break-words">{{ eventDetails[0].title
                            }}</h1>
                        <div class="flex flex-col">
                            <span class="text-lg font-extrabold text-gray-900">{{ eventDetails[0].dateLine1 }}</span>
                            <span *ngIf="eventDetails[0].dateLine2"
                                class="text-lg font-extrabold text-gray-900">{{ eventDetails[0].dateLine2 }}</span>
                        </div>
                        <div *ngIf="eventDetails[0].minPrice > 0 || eventDetails[0].maxPrice > 0"
                            class="flex items-center gap-2">
                            <span class="text-lg font-bold text-[#000000]">PRICE:</span>
                            <span class="text-lg font-semibold text-[#000000]">£{{ eventDetails[0].minPrice }} – £{{
                                eventDetails[0].maxPrice }}</span>
                        </div>
                        <div *ngIf="eventDetails[0].minPrice === 0 && eventDetails[0].maxPrice === 0"
                            class="flex items-center gap-2">
                            <span class="text-lg font-bold text-[#000000]">PRICE:</span>
                            <span class="text-lg text-[#000000]">Free Event</span>
                        </div>
                        <div *ngIf="eventDetails[0].location" class="flex items-start gap-2">
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#2E75B6"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="flex-shrink-0 mt-0.5">
                                <path d="M21 10c0 6-9 12-9 12S3 16 3 10a9 9 0 1 1 18 0z" />
                                <circle cx="12" cy="10" r="3" />
                            </svg>
                            <span class="text-md font-bold text-[#000000] tracking-wide">{{
                                eventDetails[0].location }}</span>
                        </div>
                        <span *ngIf="eventDetails[0].category && eventDetails[0].category !== 'Other'"
                            class="inline-block px-3 py-1.5 text-sm font-medium text-[#D31148] bg-[#FFD4E0] border border-[#D31148] rounded-lg cursor-pointer hover:bg-[#f5b8c9] transition-colors"
                            (click)="goToCategory(eventDetails[0].category)">
                            {{ eventDetails[0].category }}
                        </span>
                        <div *ngIf="eventDetails[0].hashtags?.length" class="flex flex-wrap gap-2">
                            <span *ngFor="let tag of eventDetails[0].hashtags" (click)="goToHashtag(tag, $event)"
                                class="text-sm font-semibold text-brand-500 hover:underline cursor-pointer">
                                #{{ tag }}
                            </span>
                        </div>
                        <div *ngIf="eventDetails[0].description"
                            class="event-prose text-sm text-gray-600 leading-relaxed"
                            [innerHTML]="getSafeHtml(eventDetails[0].description)"></div>
                        <button (click)="openBooking(eventDetails[0].linkToBookingSite)"
                            class="w-full py-3.5 rounded-xl bg-[#D31148] text-white font-bold text-sm
                                       hover:bg-[#b80e3d] transition-colors shadow-md shadow-[#D31148]/20 active:scale-[0.98]">
                            Book Now
                        </button>
                    </div>

                    <!-- ── COMMENTS TAB ────────────────────────────────────── -->
                    <div *ngIf="activeTab==='comments'" class="flex-1 flex flex-col min-h-0 overflow-hidden">

                        <!-- Scrollable comment list -->
                        <div class="flex-1 overflow-y-auto min-h-0 px-4 sm:px-5 py-4 space-y-5">

                            <!-- Loading skeleton — only on first load, not on tab re-visits -->
                            <ng-container *ngIf="commentsLoading && !commentsLoaded">
                                <div *ngFor="let s of [1,2,3]" class="flex gap-3 animate-pulse">
                                    <div class="w-9 h-9 rounded-full bg-gray-200 flex-shrink-0"></div>
                                    <div class="flex-1 space-y-2">
                                        <div class="h-3 bg-gray-200 rounded w-32"></div>
                                        <div class="h-3 bg-gray-200 rounded w-full"></div>
                                        <div class="h-3 bg-gray-200 rounded w-3/4"></div>
                                    </div>
                                </div>
                            </ng-container>

                            <!-- Empty state -->
                            <div *ngIf="!commentsLoading && commentsLoaded && comments.length === 0"
                                class="flex flex-col items-center justify-center py-12 text-center">
                                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#D31148"
                                    stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"
                                    class="opacity-30 mb-3">
                                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                                </svg>
                                <p class="text-sm text-gray-400 font-medium">No comments yet</p>
                                <p class="text-xs text-gray-400 mt-0.5">Be the first to join the conversation</p>
                            </div>

                            <!-- Comment list -->
                            <ng-container *ngFor="let comment of comments">
                                <div class="flex gap-3">
                                    <img [src]="getUserAvatar(comment)" [alt]="comment.user.displayName"
                                        [routerLink]="['/profile', comment.user.userName, 'event']"
                                        class="w-9 h-9 rounded-full object-cover flex-shrink-0 mt-0.5 cursor-pointer" />
                                    <div class="flex-1 min-w-0">

                                        <!-- Comment header -->
                                        <div class="flex items-center justify-between mb-1 gap-2">
                                            <div class="flex items-center gap-2 min-w-0">
                                                <span class="text-sm font-bold text-gray-900 truncate cursor-pointer"
                                                    [routerLink]="['/profile', comment.user.userName, 'event']">
                                                    {{ comment.user.userName }}
                                                </span>
                                                <span class="text-xs text-gray-400 whitespace-nowrap">{{
                                                    getTimeAgo(comment.createdAt) }}</span>
                                                <span *ngIf="comment.isEdited"
                                                    class="text-[10px] text-gray-400 italic">(edited)</span>
                                            </div>
                                            <div class="flex items-center gap-2 flex-shrink-0">
                                                <!-- Reply — visible to all (ableToReply always true for top-level) -->
                                                <button *ngIf="comment.ableToReply && !eventDetails[0].commentsDisabled"
                                                    (click)="toggleReply(comment._id)"
                                                    class="text-xs font-semibold transition-colors"
                                                    [class.text-[#D31148]]="replyingTo === comment._id"
                                                    [class.text-[#D31148]]="replyingTo !== comment._id">
                                                    Reply
                                                </button>
                                                <ng-container *ngIf="comment.ableToModification || canReportComment(comment)">
                                                    <div class="relative inline-block">
                                                        <button class="dropdown-toggle"
                                                            (click)="toggleDropdown(comment._id); $event.stopPropagation()">
                                                            <svg width="1em" height="1em" viewBox="0 0 24 24"
                                                                fill="none" xmlns="http://www.w3.org/2000/svg"
                                                                class="text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 size-6">
                                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                                    d="M10.2441 6C10.2441 5.0335 11.0276 4.25 11.9941 4.25H12.0041C12.9706 4.25 13.7541 5.0335 13.7541 6C13.7541 6.9665 12.9706 7.75 12.0041 7.75H11.9941C11.0276 7.75 10.2441 6.9665 10.2441 6ZM10.2441 18C10.2441 17.0335 11.0276 16.25 11.9941 16.25H12.0041C12.9706 16.25 13.7541 17.0335 13.7541 18C13.7541 18.9665 12.9706 19.75 12.0041 19.75H11.9941C11.0276 19.75 10.2441 18.9665 10.2441 18ZM11.9941 10.25C11.0276 10.25 10.2441 11.0335 10.2441 12C10.2441 12.9665 11.0276 13.75 11.9941 13.75H12.0041C12.9706 13.75 13.7541 12.9665 13.7541 12C13.7541 11.0335 12.9706 10.25 12.0041 10.25H11.9941Z"
                                                                    fill="currentColor"></path>
                                                            </svg>
                                                        </button>

                                                        <app-dropdown [isOpen]="openDropdownId === comment._id"
                                                            (close)="closeDropdown()" className="w-40 p-2">
                                                            <ng-container *ngIf="comment.ableToModification; else reportCommentItem">
                                                                <app-dropdown-item (itemClick)="startEdit(comment)"
                                                                    className="flex w-full font-normal text-left text-gray-500 rounded-lg hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300">
                                                                    Edit
                                                                </app-dropdown-item>
                                                                <app-dropdown-item (itemClick)="deleteComment(comment._id)"
                                                                    className="flex w-full font-normal text-left text-gray-500 rounded-lg hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300">
                                                                    Delete
                                                                </app-dropdown-item>
                                                            </ng-container>
                                                            <ng-template #reportCommentItem>
                                                                <app-dropdown-item (itemClick)="reportComment(comment._id)"
                                                                    className="flex w-full font-normal text-left text-gray-500 rounded-lg hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300">
                                                                    Report
                                                                </app-dropdown-item>
                                                            </ng-template>
                                                        </app-dropdown>
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </div>

                                        <ng-container *ngIf="editingCommentId === comment._id; else commentBody">
                                            <div class="flex gap-2 mt-1 items-center">
                                                <button (click)="toggleEmojiPicker($event, 'main')"
                                                    class="text-gray-400 hover:text-[#D31148] transition-colors flex-shrink-0"
                                                    [class.text-[#D31148]]="showEmojiPicker">
                                                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none"
                                                        stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                        stroke-linejoin="round">
                                                        <circle cx="12" cy="12" r="10" />
                                                        <path d="M8 14s1.5 2 4 2 4-2 4-2" />
                                                        <line x1="9" y1="9" x2="9.01" y2="9" />
                                                        <line x1="15" y1="9" x2="15.01" y2="9" />
                                                    </svg>
                                                </button>
                                                <input [(ngModel)]="editInput" type="text"
                                                    class="flex-1 text-sm border border-[#D31148] rounded-lg px-3 py-1.5 outline-none bg-white" />
                                                <button (click)="saveEdit(comment)" [disabled]="submitting" class="px-3 py-1.5 rounded-lg bg-[#D31148] text-white text-xs font-bold
             hover:bg-[#b80e3d] transition-colors disabled:opacity-50">
                                                    Save
                                                </button>
                                                <button (click)="cancelEdit()" class="px-3 py-1.5 rounded-lg border border-gray-200 text-xs font-semibold
             text-gray-600 hover:bg-gray-50 transition-colors">
                                                    Cancel
                                                </button>
                                            </div>
                                        </ng-container>

                                        <!-- Normal comment body -->
                                        <ng-template #commentBody>
                                            <p *ngIf="getTextPart(comment.body)"
                                                class="text-sm text-gray-600 leading-relaxed break-words overflow-wrap-break-word"
                                                [innerHTML]="getTextPart(comment.body) | mentionHighlight">
                                            </p>
                                            <img *ngIf="getGifPart(comment.body)" [src]="getGifPart(comment.body)"
                                                alt="GIF"
                                                class="mt-2 rounded-xl max-h-40 object-cover border border-gray-100" />
                                        </ng-template>

                                        <!-- Reply input box -->
                                        <div *ngIf="replyingTo === comment._id" [id]="'reply-input-' + comment._id"
                                            class="mt-3 relative">

                                            <!-- @mention dropdown -->
                                            <app-mention-dropdown
                                                [isOpen]="showMentionDropdown && activeMentionContext === comment._id"
                                                [users]="mentionUsers"
                                                (selected)="onMentionPicked($event, comment._id, replyDir)">
                                            </app-mention-dropdown>

                                            <div *ngIf="replyGifUrls[comment._id]" class="mb-2">
                                                <div class="relative inline-block">
                                                    <img [src]="replyGifUrls[comment._id]" alt="Selected GIF"
                                                        class="h-16 rounded-xl border border-gray-200 object-cover" />
                                                    <button (click)="removeGif(comment._id)"
                                                        class="absolute -top-1.5 -right-1.5 w-5 h-5 flex items-center justify-center
                                                           rounded-full bg-gray-800 text-white text-xs hover:bg-red-500 transition-colors">
                                                        ×
                                                    </button>
                                                </div>
                                            </div>

                                            <div class="flex gap-2">
                                                <!-- Emoji button — kept exactly as before -->
                                                <button (click)="toggleEmojiPicker($event, comment._id)"
                                                    class="text-gray-400 hover:text-[#D31148] transition-colors flex-shrink-0"
                                                    [class.text-[#D31148]]="showEmojiPicker">
                                                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none"
                                                        stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                        stroke-linejoin="round">
                                                        <circle cx="12" cy="12" r="10" />
                                                        <path d="M8 14s1.5 2 4 2 4-2 4-2" />
                                                        <line x1="9" y1="9" x2="9.01" y2="9" />
                                                        <line x1="15" y1="9" x2="15.01" y2="9" />
                                                    </svg>
                                                </button>

                                                <!-- Reply input — only added directive + mention outputs, design unchanged -->
                                                <div #replyDir="appMentionInput" appMentionInput contenteditable="true"
                                                    role="textbox" aria-multiline="false"
                                                    [attr.data-placeholder]="'Write a reply… type @ to mention'"
                                                    (mentionEnter)="submitReply(comment._id)"
                                                    (mentionSearch)="onMentionSearch($event, comment._id)"
                                                    (mentionDropdown)="onMentionDropdownChange($event, comment._id)"
                                                    (valueChange)="replyInputs[comment._id] = $event" class="mention-editable comment-mention-input flex-1 text-sm text-gray-700 outline-none
         border border-gray-200 focus:border-[#D31148]
         rounded-xl px-3 py-1.5 transition-colors bg-[#f7f7f7]">
                                                </div>

                                                <button (click)="toggleGifPicker(comment._id, $event)" class="text-xs font-black text-gray-400 hover:text-[#D31148]
                                                   transition-colors flex-shrink-0 px-1 leading-none"
                                                    [class.text-[#D31148]]="showGifPicker && activeEmojiContext === comment._id">
                                                    GIF
                                                </button>

                                                <!-- Send button — unchanged -->
                                                <button (click)="submitReply(comment._id)"
                                                    [disabled]="submitting || (!replyInputs[comment._id]?.trim() && !replyGifUrls[comment._id])"
                                                    class="w-8 h-8 flex items-center justify-center rounded-full bg-[#D31148]
                       text-white hover:bg-[#b80e3d] transition-colors disabled:opacity-50">
                                                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                                                        stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                                        stroke-linejoin="round">
                                                        <line x1="22" y1="2" x2="11" y2="13" />
                                                        <polygon points="22 2 15 22 11 13 2 9 22 2" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>

                                        <!-- Replies -->
                                        <ng-container *ngIf="comment.replies && comment.replies.length > 0">
                                            <div class="mt-3 pl-3 border-l-2 border-[#FFD4E0] space-y-3">
                                                <div *ngFor="let reply of comment.replies" class="flex gap-2.5">
                                                    <img [src]="getUserAvatar(reply)" [alt]="reply.user.displayName"
                                                        [routerLink]="['/profile', reply.user.userName, 'event']"
                                                        class="w-8 h-8 rounded-full object-cover flex-shrink-0 mt-0.5 cursor-pointer" />
                                                    <div class="flex-1 min-w-0">
                                                        <div class="flex items-center justify-between mb-1 gap-2">
                                                            <div class="flex items-center gap-2 min-w-0">
                                                                <span
                                                                    class="text-sm font-bold text-gray-900 truncate cursor-pointer"
                                                                    [routerLink]="['/profile', reply.user.userName, 'event']">
                                                                    {{ reply.user.userName }}
                                                                </span>
                                                                <span class="text-xs text-gray-400 whitespace-nowrap">{{
                                                                    getTimeAgo(reply.createdAt) }}</span>
                                                                <span *ngIf="reply.isEdited"
                                                                    class="text-[10px] text-gray-400 italic">(edited)</span>
                                                            </div>
                                                            <div class="flex items-center gap-2 flex-shrink-0">
                                                                <!-- Edit / Delete — only for reply author -->
                                                                <ng-container *ngIf="reply.ableToModification || canReportComment(reply)">
                                                                    <div class="relative inline-block">
                                                                        <button class="dropdown-toggle"
                                                                            (click)="toggleDropdown(reply._id); $event.stopPropagation()">
                                                                            <svg width="1em" height="1em"
                                                                                viewBox="0 0 24 24" fill="none"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                class="text-gray-400 hover:text-gray-700 size-6">
                                                                                <path fill-rule="evenodd"
                                                                                    clip-rule="evenodd"
                                                                                    d="M10.2441 6C10.2441 5.0335 11.0276 4.25 11.9941 4.25H12.0041C12.9706 4.25 13.7541 5.0335 13.7541 6C13.7541 6.9665 12.9706 7.75 12.0041 7.75H11.9941C11.0276 7.75 10.2441 6.9665 10.2441 6ZM10.2441 18C10.2441 17.0335 11.0276 16.25 11.9941 16.25H12.0041C12.9706 16.25 13.7541 17.0335 13.7541 18C13.7541 18.9665 12.9706 19.75 12.0041 19.75H11.9941C11.0276 19.75 10.2441 18.9665 10.2441 18ZM11.9941 10.25C11.0276 10.25 10.2441 11.0335 10.2441 12C10.2441 12.9665 11.0276 13.75 11.9941 13.75H12.0041C12.9706 13.75 13.7541 12.9665 13.7541 12C13.7541 11.0335 12.9706 10.25 12.0041 10.25H11.9941Z"
                                                                                    fill="currentColor"></path>
                                                                            </svg>
                                                                        </button>

                                                                        <app-dropdown
                                                                            [isOpen]="openDropdownId === reply._id"
                                                                            (close)="closeDropdown()"
                                                                            className="w-40 p-2">
                                                                            <ng-container *ngIf="reply.ableToModification; else reportReplyItem">
                                                                                <app-dropdown-item
                                                                                    (itemClick)="startEdit(reply); closeDropdown()"
                                                                                    className="flex w-full font-normal text-left text-gray-500 rounded-lg hover:bg-gray-100 hover:text-gray-700">
                                                                                    Edit
                                                                                </app-dropdown-item>
                                                                                <app-dropdown-item
                                                                                    (itemClick)="deleteComment(reply._id, comment._id); closeDropdown()"
                                                                                    className="flex w-full font-normal text-left text-gray-500 rounded-lg hover:bg-gray-100 hover:text-gray-700">
                                                                                    Delete
                                                                                </app-dropdown-item>
                                                                            </ng-container>
                                                                            <ng-template #reportReplyItem>
                                                                                <app-dropdown-item
                                                                                    (itemClick)="reportComment(reply._id)"
                                                                                    className="flex w-full font-normal text-left text-gray-500 rounded-lg hover:bg-gray-100 hover:text-gray-700">
                                                                                    Report
                                                                                </app-dropdown-item>
                                                                            </ng-template>
                                                                        </app-dropdown>
                                                                    </div>
                                                                </ng-container>
                                                            </div>
                                                        </div>
                                                        <!-- Edit mode for reply -->
                                                        <ng-container
                                                            *ngIf="editingCommentId === reply._id; else replyBody">
                                                            <div class="flex gap-2 mt-1">
                                                                <input [(ngModel)]="editInput" type="text"
                                                                    class="flex-1 text-sm border border-[#D31148] rounded-lg px-3 py-1.5 outline-none bg-white" />
                                                                <button (click)="saveEdit(reply)"
                                                                    [disabled]="submitting"
                                                                    class="px-3 py-1.5 rounded-lg bg-[#D31148] text-white text-xs font-bold
                                                                           hover:bg-[#b80e3d] transition-colors disabled:opacity-50">Save</button>
                                                                <button (click)="cancelEdit()"
                                                                    class="px-3 py-1.5 rounded-lg border border-gray-200 text-xs font-semibold
                                                                           text-gray-600 hover:bg-gray-50 transition-colors">Cancel</button>
                                                            </div>
                                                        </ng-container>
                                                        <ng-template #replyBody>
                                                            <p *ngIf="getTextPart(reply.body)"
                                                                class="text-sm text-gray-600 leading-relaxed break-words overflow-wrap-break-word"
                                                                [innerHTML]="getTextPart(reply.body) | mentionHighlight">
                                                            </p>
                                                            <img *ngIf="getGifPart(reply.body)"
                                                                [src]="getGifPart(reply.body)" alt="GIF"
                                                                class="mt-2 rounded-xl max-h-32 object-cover border border-gray-100" />
                                                        </ng-template>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>

                                    </div>
                                </div>
                            </ng-container>

                            <!-- Load more -->
                            <div *ngIf="commentsPage < commentsTotalPages" class="flex justify-center pt-2 pb-1">
                                <button (click)="loadMoreComments()" [disabled]="commentsLoading"
                                    class="text-xs font-semibold text-[#D31148] hover:underline disabled:opacity-50">
                                    {{ commentsLoading ? 'Loading…' : 'Load more comments' }}
                                </button>
                            </div>

                        </div><!-- end scrollable list -->

                        <!-- ── Sticky comment footer ──────────────────────── -->
                        <div class="flex-shrink-0 border-t border-gray-100 bg-white comment-picker-area"
                            style="position: relative;">

                            <!-- Quick emoji bar -->
                            <!-- <div class="flex items-center gap-1 px-3 py-2 overflow-x-auto border-b border-gray-50"
                                style="-ms-overflow-style:none; scrollbar-width:none;">
                                <button *ngFor="let e of QUICK_EMOJIS" (click)="appendQuickEmoji(e)" class="text-lg flex-shrink-0 w-9 h-9 flex items-center justify-center
                                           rounded-full hover:bg-gray-100 hover:scale-125 transition-all">
                                    {{ e }}
                                </button>
                            </div> -->

                            <!-- GIF preview strip -->
                            <div *ngIf="selectedGifUrl" class="flex items-center gap-2 px-3 pt-2">
                                <div class="relative inline-block">
                                    <img [src]="selectedGifUrl" alt="Selected GIF"
                                        class="h-16 rounded-xl border border-gray-200 object-cover" />
                                    <button (click)="removeGif()"
                                        class="absolute -top-1.5 -right-1.5 w-5 h-5 flex items-center justify-center
                                               rounded-full bg-gray-800 text-white text-xs hover:bg-red-500 transition-colors">
                                        ×
                                    </button>
                                </div>
                            </div>

                            <!-- Comments disabled banner -->
                            <div *ngIf="eventDetails[0].commentsDisabled"
                                class="mx-3 my-3 px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl flex items-center gap-2 text-sm text-gray-500">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                    class="flex-shrink-0">
                                    <circle cx="12" cy="12" r="10" />
                                    <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
                                </svg>
                                Comments have been turned off for this event.
                            </div>

                            <!-- Input row -->
                            <div *ngIf="!eventDetails[0].commentsDisabled"
                                class="flex items-center gap-2 px-3 sm:px-4 py-3">
                                <img [src]="getCurrentUserAvatar()" alt="me"
                                    class="w-8 h-8 rounded-full object-cover flex-shrink-0" />

                                <div class="flex-1 relative">

                                    <!-- @mention dropdown anchored above the main input -->
                                    <app-mention-dropdown
                                        [isOpen]="showMentionDropdown && activeMentionContext === 'main'"
                                        [users]="mentionUsers" (selected)="onMentionPicked($event, 'main', mainDir)">
                                    </app-mention-dropdown>

                                    <div class="flex items-center gap-2 bg-[#f7f7f7] rounded-xl px-3 py-2
                border border-gray-200 focus-within:border-[#D31148] transition-colors min-w-0">
                                        <button (click)="toggleEmojiPicker($event, 'main')"
                                            class="text-gray-400 hover:text-[#D31148] transition-colors flex-shrink-0"
                                            [class.text-[#D31148]]="showEmojiPicker">
                                            <svg width="17" height="17" viewBox="0 0 24 24" fill="none"
                                                stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round">
                                                <circle cx="12" cy="12" r="10" />
                                                <path d="M8 14s1.5 2 4 2 4-2 4-2" />
                                                <line x1="9" y1="9" x2="9.01" y2="9" />
                                                <line x1="15" y1="9" x2="15.01" y2="9" />
                                            </svg>
                                        </button>

                                        <div #mainDir="appMentionInput" appMentionInput contenteditable="true"
                                            role="textbox" aria-multiline="false"
                                            [attr.data-placeholder]="'Join the conversation… type @ to mention'"
                                            (mentionEnter)="submitComment()"
                                            (mentionSearch)="onMentionSearch($event, 'main')"
                                            (mentionDropdown)="onMentionDropdownChange($event, 'main')"
                                            (valueChange)="commentInput = $event"
                                            class="mention-editable comment-mention-input flex-1 text-sm text-gray-700 outline-none min-w-0">
                                        </div>

                                        <button (click)="toggleGifPicker('main', $event)" class="text-xs font-black text-gray-400 hover:text-[#D31148]
                       transition-colors flex-shrink-0 px-1 leading-none" [class.text-[#D31148]]="showGifPicker">
                                            GIF
                                        </button>
                                    </div>
                                </div>
                                <div class="flex items-center gap-1.5 flex-shrink-0">
                                    <button (click)="submitComment()"
                                        [disabled]="submitting || (!commentInput.trim() && !selectedGifUrl)"
                                        class="w-8 h-8 flex items-center justify-center rounded-full bg-[#D31148] text-white
                                               hover:bg-[#b80e3d] transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                                            stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                            stroke-linejoin="round">
                                            <line x1="22" y1="2" x2="11" y2="13" />
                                            <polygon points="22 2 15 22 11 13 2 9 22 2" />
                                        </svg>
                                    </button>
                                </div>
                            </div>

                            <!-- Full emoji picker panel -->
                            <div *ngIf="showEmojiPicker" class="absolute bottom-full left-0 right-0 mx-3 mb-1 bg-white rounded-2xl border border-gray-200
                                       shadow-xl z-[500] overflow-hidden" (click)="$event.stopPropagation()">
                                <div class="flex border-b border-gray-100 px-2 pt-2 gap-1">
                                    <button *ngFor="let cat of EMOJI_CATEGORIES; let i = index" (click)="setEmojiTab(i)"
                                        class="px-3 py-1.5 rounded-lg text-xs font-semibold transition-colors"
                                        [class.bg-[#D31148]]="activeEmojiTab === i"
                                        [class.text-white]="activeEmojiTab === i"
                                        [class.text-gray-500]="activeEmojiTab !== i"
                                        [class.hover:bg-gray-100]="activeEmojiTab !== i">
                                        {{ cat.label }}
                                    </button>
                                </div>
                                <div class="flex flex-wrap gap-0.5 p-3 max-h-40 overflow-y-auto">
                                    <button *ngFor="let emoji of EMOJI_CATEGORIES[activeEmojiTab].emojis"
                                        (click)="pickEmoji(emoji)" class="text-xl w-9 h-9 flex items-center justify-center rounded-lg
                                               hover:bg-gray-100 hover:scale-110 transition-all">
                                        {{ emoji }}
                                    </button>
                                </div>
                            </div>

                            <!-- GIF picker panel -->
                            <div *ngIf="showGifPicker" class="absolute bottom-full left-0 right-0 mx-3 mb-1 bg-white rounded-2xl border border-gray-200
                                       shadow-xl z-[500] overflow-hidden" (click)="$event.stopPropagation()">
                                <div class="flex items-center gap-2 p-3 border-b border-gray-100">
                                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#9ca3af"
                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <circle cx="11" cy="11" r="8" />
                                        <line x1="21" y1="21" x2="16.65" y2="16.65" />
                                    </svg>
                                    <input [(ngModel)]="gifSearchQuery" type="text"
                                        placeholder="Search GIFs (powered by GIPHY)…" (keyup)="onGifSearchKey($event)"
                                        class="flex-1 text-sm outline-none text-gray-700 placeholder-gray-400 bg-transparent" />
                                    <button (click)="searchGifs()"
                                        class="text-xs font-bold text-[#D31148] hover:underline">Search</button>
                                </div>
                                <div class="p-2 max-h-48 overflow-y-auto">
                                    <div *ngIf="gifLoading" class="flex items-center justify-center py-8">
                                        <div
                                            class="w-6 h-6 border-2 border-[#D31148] border-t-transparent rounded-full animate-spin">
                                        </div>
                                    </div>
                                    <div *ngIf="!gifLoading && gifResults.length === 0"
                                        class="py-8 text-center text-sm text-gray-400">
                                        <p>No GIFs found.</p>
                                    </div>
                                    <div *ngIf="!gifLoading && gifResults.length > 0"
                                        class="grid grid-cols-3 sm:grid-cols-4 gap-1.5">
                                        <button *ngFor="let gif of gifResults" (click)="selectGif(gif)"
                                            class="rounded-xl overflow-hidden hover:ring-2 hover:ring-[#D31148] transition-all aspect-video">
                                            <img [src]="gif.preview" alt="GIF" class="w-full h-full object-cover"
                                                loading="lazy" />
                                        </button>
                                    </div>
                                    <p *ngIf="gifResults.length > 0" class="text-[10px] text-gray-400 text-center pt-2">
                                        Powered by GIPHY</p>
                                </div>
                            </div>

                        </div><!-- end sticky footer -->
                    </div><!-- end comments tab -->

                    <!-- Mobile reaction strip -->
                    <div class="flex lg:hidden items-center justify-around py-2.5 border-t border-gray-100
                                flex-shrink-0 px-6 bg-white" style="position: relative; overflow: visible;">
                        <div class="relative flex items-center gap-1.5" style="overflow: visible;">
                            <div *ngIf="eventDetails[0].showEmojiPicker" class="absolute z-[999] flex items-end gap-1 rounded-full bg-white px-2 py-2
                                       shadow-[0_4px_20px_rgba(0,0,0,0.2)] border border-gray-100"
                                style="bottom: calc(100% + 10px); left: 0; pointer-events: auto;"
                                (mouseleave)="closeEmojiPicker(eventDetails[0])">
                                <button *ngFor="let r of REACTIONS; let i = index"
                                    (click)="onEmojiPick(eventDetails[0], r.type, $event)"
                                    (mouseenter)="eventDetails[0].hoveredReaction = r.type"
                                    (mouseleave)="eventDetails[0].hoveredReaction = null"
                                    class="flex flex-col items-center cursor-pointer"
                                    [style.animation-delay.ms]="i * 30" [title]="r.label">
                                    <span class="flex items-center justify-center rounded-full"
                                        [style.background]="r.bg"
                                        [class.scale-125]="eventDetails[0].hoveredReaction === r.type"
                                        [class.-translate-y-2]="eventDetails[0].hoveredReaction === r.type"
                                        style="width:36px;height:36px;font-size:19px;line-height:1;transition:transform 0.15s cubic-bezier(0.34,1.56,0.64,1);">
                                        {{ r.emoji }}
                                    </span>
                                </button>
                            </div>
                            <button class="flex items-center gap-1.5" (click)="onReactionClick(eventDetails[0])">
                                <ng-container *ngIf="!eventDetails[0].myReaction">
                                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#6b7280"
                                        stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                        <path d="M7 10v12" />
                                        <path
                                            d="M15 5.88L14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z" />
                                    </svg>
                                    <span class="text-xs font-semibold text-gray-500">{{ eventDetails[0].totalReactions
                                        }}</span>
                                </ng-container>
                                <ng-container *ngIf="eventDetails[0].myReaction">
                                    <span class="flex items-center justify-center rounded-full"
                                        [style.background]="getReactionConfig(eventDetails[0].myReaction)?.bg"
                                        style="width:26px;height:26px;font-size:16px;line-height:1;">
                                        {{ getReactionConfig(eventDetails[0].myReaction)?.emoji }}
                                    </span>
                                    <span class="text-xs font-semibold"
                                        [style.color]="getReactionConfig(eventDetails[0].myReaction)?.color">
                                        {{ eventDetails[0].totalReactions }}
                                    </span>
                                </ng-container>
                            </button>
                        </div>
                        <button class="flex items-center gap-1.5 text-gray-500 hover:text-[#D31148] transition-colors"
                            (click)="openShareSheet()">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                <g opacity="0.7">
                                    <path
                                        d="M20.7914 12.6075C21.0355 12.3982 21.1575 12.2936 21.2023 12.1691C21.2415 12.0598 21.2415 11.9403 21.2023 11.831C21.1575 11.7065 21.0355 11.6019 20.7914 11.3926L12.3206 4.13202C11.9004 3.77182 11.6903 3.59172 11.5124 3.58731C11.3578 3.58348 11.2101 3.6514 11.1124 3.77128C11 3.90921 11 4.18595 11 4.73942V9.03468C8.86532 9.40813 6.91159 10.4898 5.45971 12.1139C3.87682 13.8846 3.00123 16.176 3 18.551V19.163C4.04934 17.8989 5.35951 16.8766 6.84076 16.166C8.1467 15.5395 9.55842 15.1684 11 15.0706V19.2607C11 19.8141 11 20.0909 11.1124 20.2288C11.2101 20.3487 11.3578 20.4166 11.5124 20.4128C11.6903 20.4084 11.9004 20.2283 12.3206 19.8681L20.7914 12.6075Z"
                                        stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </g>
                            </svg>
                            <span class="text-xs font-semibold">{{ eventDetails[0].shares }}</span>
                        </button>
                        <button class="flex items-center gap-1.5 text-gray-500" (click)="switchTab('comments')">
                            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                            </svg>
                            <span class="text-xs font-semibold">{{ eventDetails[0].comments }}</span>
                        </button>
                    </div>

                </div><!-- end right panel -->
            </div><!-- end hero row -->

            <!-- Recommended -->
            <div class="py-10">

                <!-- Section header -->
                <div class="flex items-center justify-between mb-6">
                    <h2 class="text-xl font-bold text-gray-900">Recommended for you</h2>
                    <button (click)="goToAllEvents()"
                        class="flex items-center gap-1.5 text-sm font-semibold text-gray-600 hover:text-[#D31148] transition-colors group">
                        View all
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                            class="group-hover:translate-x-0.5 transition-transform">
                            <path d="M5 12h14" />
                            <path d="m12 5 7 7-7 7" />
                        </svg>
                    </button>
                </div>

                <!-- Cards come from the Events listing component itself rather than a
                     copy of its markup — that is what keeps this section identical to
                     /events, and keeps it identical as that card changes. In mixedMode
                     the component's own wrappers are `display: contents`, so each card
                     lands as a direct child of this grid. -->
                <div class="recommended-events-grid">
                    <app-events [mixedItems]="recommendedRawItems" [mixedMode]="true" [embedded]="true"
                        [gridCols]="4"></app-events>
                </div>

                <!-- Empty state -->
                <div *ngIf="recommendedRawItems.length === 0"
                    class="flex flex-col items-center justify-center py-10 text-gray-400">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
                        stroke-linecap="round" stroke-linejoin="round" class="mb-2 opacity-40">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                        <line x1="16" y1="2" x2="16" y2="6" />
                        <line x1="8" y1="2" x2="8" y2="6" />
                        <line x1="3" y1="10" x2="21" y2="10" />
                    </svg>
                    <p class="text-sm">No recommendations available</p>
                </div>

            </div>

        </ng-container>

        <ng-template #loading>
            <div *ngIf="hasError"
                class="flex flex-col items-center justify-center rounded-2xl border border-[#e6e6e6] bg-white shadow-sm p-16 text-center">
                <p class="text-sm text-gray-500">Failed to load event. Please try again.</p>
            </div>
            <div *ngIf="isLoading" class="flex flex-col lg:flex-row rounded-2xl border border-[#e6e6e6] bg-white shadow-sm overflow-hidden
                       lg:h-[calc(100vh-300px)] h-[calc(100vh-105px)] animate-pulse">
                <div class="w-full lg:w-[58%] bg-gray-200 h-full"></div>
                <div class="flex-1 p-6 space-y-4">
                    <div class="flex items-center gap-3">
                        <div class="w-12 h-12 rounded-full bg-gray-200"></div>
                        <div class="space-y-2 flex-1">
                            <div class="h-4 bg-gray-200 rounded w-32"></div>
                            <div class="h-3 bg-gray-200 rounded w-20"></div>
                        </div>
                    </div>
                    <div class="h-4 bg-gray-200 rounded w-full"></div>
                    <div class="h-4 bg-gray-200 rounded w-3/4"></div>
                    <div class="h-10 bg-gray-200 rounded-xl w-full mt-8"></div>
                </div>
            </div>
        </ng-template>

    </div>
</section>

<app-modal [isOpen]="isReactionOpen" (close)="closeReactionModal()" className="max-w-[700px]">
    <div class="relative w-full h-full flex flex-col bg-white dark:bg-gray-900 rounded-3xl overflow-hidden">

        <!-- Header - FIXED -->
        <div class="flex-shrink-0 bg-white dark:bg-gray-900 border-b border-gray-200">
            <div class="flex items-center gap-1 overflow-x-auto px-6 pt-5 pb-3">
                <button (click)="setReactionFilter(null)"
                    class="flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-semibold whitespace-nowrap transition-colors"
                    [class.text-[#D31148]]="activeReactionFilter === null"
                    [class.border-b-2]="activeReactionFilter === null"
                    [class.border-[#D31148]]="activeReactionFilter === null"
                    [class.text-gray-500]="activeReactionFilter !== null">
                    All <span class="font-bold">{{ reactionData?.total ?? 0 }}</span>
                </button>
                <ng-container *ngFor="let r of REACTIONS">
                    <button (click)="setReactionFilter(r.type)"
                        class="flex items-center gap-1 px-3 py-2 rounded-lg text-sm font-semibold whitespace-nowrap transition-colors"
                        [class.text-[#D31148]]="activeReactionFilter === r.type"
                        [class.border-b-2]="activeReactionFilter === r.type"
                        [class.border-[#D31148]]="activeReactionFilter === r.type"
                        [class.text-gray-500]="activeReactionFilter !== r.type">
                        <span style="font-size:18px;line-height:1;">{{ r.emoji }}</span>
                        <span>{{ reactionData?.counts?.[r.type] ?? 0 }}</span>
                    </button>
                </ng-container>
            </div>
        </div>

        <!-- Content - SCROLLABLE -->
        <div class="flex-1 overflow-y-auto px-6 py-4">
            <div *ngIf="reactionsLoading" class="flex items-center justify-center py-12">
                <div class="h-8 w-8 animate-spin rounded-full border-4 border-[#e8e8e8] border-t-[#D31148]"></div>
            </div>

            <div *ngIf="!reactionsLoading" class="space-y-1">
                <div *ngFor="let item of filteredReactions"
                    class="flex items-center gap-3 rounded-xl px-2 py-2.5 hover:bg-[#fafafa] transition-colors">
                    <div class="relative flex-shrink-0">
                        <img [src]="item.user?.profileImage?.urlSmall || avatarFallback(item.user?.displayName)"
                            class="h-11 w-11 rounded-full object-cover border border-[#f0f0f0]"
                            [alt]="item.user?.displayName" />
                        <span
                            class="absolute -bottom-0.5 -right-0.5 flex h-5 w-5 items-center justify-center rounded-full border-2 border-white text-[11px] shadow-sm"
                            [style.background]="getReactionConfig(item.type)?.bg">{{ item.emoji }}</span>
                    </div>
                    <div class="flex-1 min-w-0">
                        <div class="font-semibold text-gray-800 text-sm truncate">{{ item.user?.userName }}</div>
                        <div class="text-xs text-gray-400 truncate">{{ item.user?.displayName }}</div>
                    </div>
                    <div class="flex items-center gap-2 flex-shrink-0">

                        <!-- Friend request button -->
                        <button (click)="onModalFriendClick(item, $event)" *ngIf="!item.isMe"
                            [title]="friendButtonTitle(item.friendship.status ?? 'NONE')"
                            [disabled]="item.friendship.status === 'BLOCKED'"
                            class="flex items-center justify-center w-8 h-8 rounded-full border transition-colors disabled:opacity-40"
                            [ngClass]="item.friendship.status === 'FRIENDS'
                    ? 'border-emerald-500 text-emerald-500 hover:bg-emerald-50'
                    : item.friendship.status === 'PENDING_SENT'
                        ? 'border-orange-400 text-orange-400 hover:bg-orange-50'
                        : 'border-[#D31148] text-[#D31148] hover:bg-[#FFF0F3]'">

                            <!-- NONE: add friend -->
                            <svg *ngIf="!item.friendship.status || item.friendship.status === 'NONE'" width="15"
                                height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                <circle cx="9" cy="7" r="4" />
                                <line x1="19" y1="8" x2="19" y2="14" />
                                <line x1="22" y1="11" x2="16" y2="11" />
                            </svg>

                            <!-- PENDING_SENT: cancel -->
                            <svg *ngIf="item.friendship.status === 'PENDING_SENT'" width="15" height="15"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                <circle cx="9" cy="7" r="4" />
                                <line x1="17" y1="8" x2="23" y2="14" />
                                <line x1="23" y1="8" x2="17" y2="14" />
                            </svg>

                            <!-- PENDING_RECEIVED -->
                            <svg *ngIf="item.friendship.status === 'PENDING_RECEIVED'" width="15" height="15"
                                viewBox="0 0 24 24" fill="none" stroke="#6366f1" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                <circle cx="9" cy="7" r="4" />
                                <polyline points="16 11 18 13 22 9" />
                            </svg>

                            <!-- FRIENDS: unfriend -->
                            <svg *ngIf="item.friendship.status === 'FRIENDS'" width="15" height="15" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                <circle cx="9" cy="7" r="4" />
                                <polyline points="16 11 18 13 22 9" />
                            </svg>

                            <!-- BLOCKED -->
                            <svg *ngIf="item.friendship.status === 'BLOCKED'" width="15" height="15" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <circle cx="12" cy="12" r="10" />
                                <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
                            </svg>

                        </button>

                        <!-- Follow / Unfollow button -->
                        <button (click)="onModalFollowClick(item, $event)" *ngIf="!item.isMe"
                            class="flex-shrink-0 px-3 py-1.5 text-xs font-semibold rounded-lg transition-colors"
                            [ngClass]="item.isFollowed
                    ? 'text-gray-700 bg-[#f8f8f8] border border-[#d8d8d8] hover:bg-gray-100'
                    : 'text-green-700 bg-green-100 border border-green-600 hover:bg-green-200'">
                            {{ item.isFollowed ? 'Unfollow' : 'Follow' }}
                        </button>

                    </div>
                </div>
                <div *ngIf="filteredReactions.length === 0"
                    class="flex flex-col items-center justify-center py-12 text-gray-400">
                    <span style="font-size:40px;">🤷</span>
                    <p class="mt-2 text-sm">No reactions yet</p>
                </div>
            </div>
        </div>

    </div>
</app-modal>

<div *ngIf="showCollabModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
    (click)="closeCollaboratorsModal()">
    <div class="max-h-[80vh] w-full max-w-sm overflow-hidden rounded-2xl bg-white" (click)="$event.stopPropagation()">
        <div class="flex items-center justify-between border-b border-gray-200 p-4">
            <h3 class="text-lg font-bold">Collaborators</h3>
            <button (click)="closeCollaboratorsModal()" class="text-gray-400 transition-colors hover:text-gray-600">
                <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
            </button>
        </div>

        <div class="max-h-[calc(80vh-80px)] overflow-y-auto">
            <!-- Host row -->
            <div class="flex items-center gap-3 p-4 transition-colors hover:bg-gray-50 cursor-pointer"
                [routerLink]="['/profile', selectedEvent?.hostName, 'event']">
                <img [src]="selectedEvent?.hostAvatar" [alt]="selectedEvent?.hostName || 'Host'"
                    class="h-12 w-12 rounded-full border-2 border-white object-cover flex-shrink-0"
                    onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />
                <div class="min-w-0 flex-1">
                    <div class="truncate font-semibold text-gray-900">{{ selectedEvent?.hostName }}</div>
                    <div class="text-sm text-gray-500">Author</div>
                </div>
            </div>

            <!-- Collaborator rows -->
            <div *ngFor="let collab of selectedEvent?.acceptedCollaborators"
                class="flex items-center gap-3 p-4 transition-colors hover:bg-gray-50 cursor-pointer"
                [routerLink]="['/profile', collab.userName, 'event']">
                <img [src]="collab.profileImage?.urlSmall" [alt]="collab.displayName"
                    class="h-12 w-12 rounded-full border-2 border-white object-cover flex-shrink-0"
                    onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />
                <div class="min-w-0 flex-1">
                    <div class="truncate font-semibold text-gray-900">@{{ collab.userName }}</div>
                    <div class="truncate text-sm text-gray-500">{{ collab.displayName }}</div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="showTaggedModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
    (click)="closeTaggedPeopleModal()">
    <div class="max-h-[80vh] w-full max-w-sm overflow-hidden rounded-2xl bg-white" (click)="$event.stopPropagation()">
        <div class="flex items-center justify-between border-b border-gray-200 p-4">
            <h3 class="text-lg font-bold">Tagged People</h3>
            <button (click)="closeTaggedPeopleModal()" class="text-gray-400 transition-colors hover:text-gray-600">
                <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
            </button>
        </div>

        <div class="max-h-[calc(80vh-80px)] overflow-y-auto">
            <div *ngFor="let tagged of selectedEvent?.rawMentions"
                class="flex items-center gap-3 p-4 transition-colors hover:bg-gray-50 cursor-pointer"
                [routerLink]="['/profile', tagged.userName, 'event']">
                <img [src]="tagged.profileImage?.urlSmall" [alt]="tagged.displayName"
                    class="h-12 w-12 rounded-full border-2 border-white object-cover flex-shrink-0"
                    onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />
                <div class="min-w-0 flex-1">
                    <div class="truncate font-semibold text-gray-900">@{{ tagged.userName }}</div>
                    <div class="truncate text-sm text-gray-500">{{ tagged.displayName }}</div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-confirmation-popup [isOpen]="showLoginPrompt" icon="user-add" title="Login Required"
    [message]="'To ' + loginPromptAction" [highlightedName]="loginPromptUserName"
    messageSuffix="you need to be logged in first" confirmLabel="Log In" cancelLabel="Close" (confirmed)="goToLogin()"
    (cancelled)="closeLoginPrompt()">
</app-confirmation-popup>

<app-friend-request-limit-popup [isOpen]="showFriendLimitPopup" [hours]="friendLimitHours"
    (closed)="showFriendLimitPopup = false"></app-friend-request-limit-popup>

<app-confirmation-popup [isOpen]="showUnfriendConfirm" icon="warning" title="Unfriend User"
    message="Are you sure you want to unfriend this user?" confirmLabel="Unfriend" cancelLabel="Cancel"
    (confirmed)="confirmUnfriend()" (cancelled)="cancelUnfriendConfirm()"></app-confirmation-popup>

<!-- Delete event confirmation -->
<app-confirmation-popup [isOpen]="showDeleteConfirm" icon="warning" title="Delete Event"
    message="Are you sure you want to permanently delete this event? All media will also be removed."
    confirmLabel="Delete" cancelLabel="Cancel" (confirmed)="doDeleteEvent()" (cancelled)="cancelDelete()">
</app-confirmation-popup>

<!-- Leave event collaboration confirmation -->
<app-confirmation-popup [isOpen]="showLeaveConfirm" icon="warning" title="Leave Collaboration"
    message="Are you sure you want to remove yourself from this event collaboration?" confirmLabel="Leave"
    cancelLabel="Cancel" (confirmed)="doLeaveCollaboration()" (cancelled)="cancelLeave()">
</app-confirmation-popup>

<!-- Report Event -->
<app-report-modal [isOpen]="isReportModalOpen" targetLabel="Event" [isSubmitting]="isSubmittingReport"
    [errorMessage]="reportError" (submitted)="submitEventReport($event)" (cancelled)="closeReportModal()">
</app-report-modal>

<app-confirmation-popup [isOpen]="reportSuccessOpen" icon="info" title="Report Submitted"
    message="Thanks for letting us know. Our team will review it shortly." confirmLabel="" cancelLabel="Close"
    (cancelled)="closeReportSuccess()"></app-confirmation-popup>

<!-- Block User (safeword-confirm) -->
<app-block-user-confirm [isOpen]="showBlockUserConfirm" [targetName]="eventToBlockDisplayName"
    (confirmed)="confirmBlockEventUser()" (cancelled)="cancelBlockEventUser()"></app-block-user-confirm>

<!-- Report Comment -->
<app-report-modal [isOpen]="isCommentReportModalOpen" targetLabel="Comment" [isSubmitting]="isSubmittingCommentReport"
    [errorMessage]="commentReportError" (submitted)="submitCommentReport($event)" (cancelled)="closeCommentReportModal()">
</app-report-modal>

<app-confirmation-popup [isOpen]="commentReportSuccessOpen" icon="info" title="Report Submitted"
    message="Thanks for letting us know. Our team will review it shortly." confirmLabel="" cancelLabel="Close"
    (cancelled)="closeCommentReportSuccess()"></app-confirmation-popup>

<app-share-sheet *ngIf="shareConfig" [config]="shareConfig" [currentCount]="shareCount" (closed)="closeShareSheet()"
    (countUpdated)="onShareCountUpdated($event)">
</app-share-sheet>

<style>
    /* ── Rich event description content ──────────────────────────────────────── */
    ::ng-deep .event-prose p {
        margin-bottom: 1rem;
    }

    ::ng-deep .event-prose h1 {
        font-size: 1.875rem;
        font-weight: 700;
        margin-bottom: .75rem;
        color: #111827;
    }

    ::ng-deep .event-prose h2 {
        font-size: 1.5rem;
        font-weight: 700;
        margin-bottom: .75rem;
        color: #111827;
    }

    ::ng-deep .event-prose h3 {
        font-size: 1.25rem;
        font-weight: 600;
        margin-bottom: .5rem;
        color: #111827;
    }

    ::ng-deep .event-prose h4 {
        font-size: 1.125rem;
        font-weight: 600;
        margin-bottom: .5rem;
        color: #111827;
    }

    ::ng-deep .event-prose h5 {
        font-size: 1rem;
        font-weight: 600;
        margin-bottom: .5rem;
        color: #111827;
    }

    ::ng-deep .event-prose h6 {
        font-size: .875rem;
        font-weight: 600;
        margin-bottom: .5rem;
        color: #111827;
    }

    ::ng-deep .event-prose ul {
        list-style: disc;
        padding-left: 1.5rem;
        margin-bottom: 1rem;
    }

    ::ng-deep .event-prose ol {
        list-style: decimal;
        padding-left: 1.5rem;
        margin-bottom: 1rem;
    }

    ::ng-deep .event-prose li {
        margin-bottom: .25rem;
    }

    ::ng-deep .event-prose b,
    ::ng-deep .event-prose strong {
        font-weight: 700;
    }

    ::ng-deep .event-prose i,
    ::ng-deep .event-prose em {
        font-style: italic;
    }

    ::ng-deep .event-prose u {
        text-decoration: underline;
    }

    ::ng-deep .event-prose a {
        color: #D31148;
        text-decoration: underline;
    }

    ::ng-deep .event-prose blockquote {
        border-left: 4px solid #D31148;
        padding: 8px 16px;
        margin: 1rem 0;
        color: #555;
        font-style: italic;
        background: #fff5f7;
        border-radius: 0 6px 6px 0;
    }

    ::ng-deep .event-prose img {
        max-width: 100%;
        height: auto;
        border-radius: 6px;
        margin: .5rem 0;
        display: block;
    }

    ::ng-deep .event-prose table {
        border-collapse: collapse;
        width: 100%;
        margin-bottom: 1rem;
    }

    ::ng-deep .event-prose td,
    ::ng-deep .event-prose th {
        border: 1px solid #d1d5db;
        padding: 8px 12px;
        text-align: left;
    }

    ::ng-deep .event-prose th {
        background: #f9fafb;
        font-weight: 600;
    }

    ::ng-deep .event-prose hr {
        border: none;
        border-top: 2px solid #e5e7eb;
        margin: 1.5rem 0;
    }
</style>
<style>
    /* Masonry track for the recommended cards. The Events component sizes each
       card with `grid-row: span N` against a 10px row, so this grid has to
       declare the same `grid-auto-rows` its own listing grid uses or the spans
       resolve against the wrong unit and the cards overlap.
       Breakpoints mirror .all-mixed-grid, the other host of these cards. */
    .recommended-events-grid {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        grid-auto-rows: 10px;
        gap: 0 20px;
    }

    @media (max-width: 1280px) {
        .recommended-events-grid {
            grid-template-columns: repeat(3, minmax(0, 1fr));
        }
    }

    @media (max-width: 900px) {
        .recommended-events-grid {
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }
    }

    @media (max-width: 560px) {
        .recommended-events-grid {
            grid-template-columns: 1fr;
        }
    }
</style>
